export const NLS_SEARCH_KEY_LOCAL_STORAGE = 'isNLSSearchOn';
